import { useRoute } from "wouter"

import { TimetableStoreProvider } from "../timetable/lib/useTimetableStore"

import TimetableContent from "./TimetableContent"

export default function Timetable() {
  const [match, params] = useRoute("/timetable-v2/:locationId/:roomIds")

  if (!match) {
    return null
  }

  return (
    <TimetableStoreProvider
      locationId={params.locationId}
      roomNumbers={params.roomIds.split(",").map((val) => parseInt(val))}>
      {({ storeApi: _storeApi }): React.JSX.Element => {
        return <TimetableContent />
      }}
    </TimetableStoreProvider>
  )
}
